import Axios from "axios";
import _ from "lodash";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getClient(id, encoded, index) {
        return Axios.get(`${baseURL}actor/client/${id}`, {
            params: { encoded, index }
        }).then(response => response.data.response);
    },
    update(id, params) {
        return Axios.put(`${baseURL}actor/client/${id}`, params).then(
            response => response.data.response
        );
    },
    updateClient(params) {
        let formData = new FormData();

        _.forEach(params, function (value, key) {
            if (_.isArray(value)) {
                _.forEach(value, function (objValue) {
                    formData.append(key + "[]", objValue);
                });
            } else {
                formData.append(key, value);
            }
        });

        return Axios.post(`${baseURLci}client/client/save`, formData).then(
            response => response.data
        );
    },
    getRelationships(id, params) {
        return Axios.get(`${baseURL}actor/relationship/${id}`, { params }).then(
            response => response.data.response
        );
    },
    deleteRelationship(params) {
        return Axios.delete(`${baseURLci}client/pet/remove`, { params }).then(
            response => response.data
        );
    },
    updateClientPhoto(params) {
        return Axios.post(`${baseURLci}client/client/save_photo`, params, {
            headers: { "Content-Type": params.type }
        }).then(response => response.data);
    },
    getLocations(id) {
        return Axios.get(`${baseURL}actor/client/${id}/location`).then(
            response => response.data.response
        );
    },
    getAllClientContact() {
        return Axios.get(`${baseURL}actor/all-client-contact`).then(
            response => response.data.response
        );
    },
    deleteClient(id, params) {
        return Axios.get(`${baseURLci}client/client/remove?id=${id}`, {
            params
        }).then(response => response.data);
    },
    mergeClient(params) {
        return Axios.post(`${baseURL}actor/merge-client`, params).then(
            response => response.data.response
        );
    },
    saveNewClient(params) {
        let formData = new FormData();

        for (const key in params) {
            let value = params[key];

            if (key === "reminder_options") {
                for (let reminder of value) {
                    formData.append("reminder_options[]", reminder.value);
                }
            } else if (key === "exempt_options") {
                for (let exempt of value) {
                    formData.append("exempt_options[]", exempt.id);
                }
            } else if (key === "referredBy" && value) {
                let prefixMap = {
                    0: "[actor]",
                    1: "[business]",
                    2: "[campaign]"
                };

                let referrerValue = `${prefixMap[value.type]}${value.id}`;

                formData.append("referrer_id", referrerValue);
                formData.append("referrer", value.label);
            } else {
                formData.append(key, value ? value : "");
            }
        }

        return Axios.post(`${baseURLci}client/client/save`, formData).then(
            response => response
        );
    },
    getWellnessPlanByClient(clientId) {
        return Axios.get(
            `${baseURL}actor/client/${clientId}/wellness-plan`
        ).then(response => response.data.response);
    },
    getWellnessPlanByPaymentMethod(clientId, paymentMethodId) {
        return Axios.get(
            `${baseURL}actor/client/${clientId}/wellness-plan?where=['payment_method_profile_id,=,${paymentMethodId}']`
        ).then(response => response.data.response);
    },
    getWellnessPlanByPatient(clientId, patientId) {
        return Axios.get(
            `${baseURL}actor/client/${clientId}/wellness-plan?where=['patient_id,=,${patientId}']`
        ).then(response => response.data.response);
    },
    getClientByGroupCompany(query) {
        return Axios.get(`${baseURL}actor/group-client-search`, {
            params: { query }
        }).then(response => response.data.response);
    },
    getPatientsByClient(id, status = 1, patient_actors) {
        return Axios.get(`${baseURL}actor/client/${id}/patient`, {
            params: { status, patient_actors }
        }).then(response => response.data.response.resources);
    },
    getClientList(query) {
        return Axios.get(`${baseURL}actor/client-search`, {
            params: { query }
        }).then(response => response.data.response);

        // promise = vm.$http
        //                .get(
        //                    process.env.ACTOR_SERVICE +
        //                        "client-search?reminder_options&query=" +
        //                        encodeURIComponent(search)
        //                )
        //                .then(res => {
        //                    vm.remote_options = get(
        //                        res,
        //                        "data.response.resource",
        //                        []
        //                    );
        //                    return vm.remote_options;
        //                });
    },
    deletePhoto(params) {
        return Axios.delete(`${baseURL}record/delete-photo`, {
            params
        }).then(response => response.data);
    },
    rotatePhoto(params) {
        return Axios.post(`${baseURLci}ajax/client/rotate_photo`, params, {
            headers: { "Content-Type": params.type }
        }).then(response => response.data);
    },
    getClientHistoryLogs(clientId, page) {
        return Axios.get(
            `${baseURL}actor/client/information-change-history?client_id=${clientId}&perPage=20&page=${page}`
        ).then(response => response.data);
    }
};
